import classNames from 'classnames';
import { default as DividerAsset } from '@/assets/graphics/divider.svg';
import styles from './divider.module.scss';

export interface DividerProps {
  /** The class name to apply */
  className?: string;
}

const Divider = ({ className }: DividerProps) => {
  return (
    <div className={classNames(styles.component, className)}>
      <DividerAsset className={styles.asset} height="12" width="1228" />
    </div>
  );
};

Divider.displayName = 'Divider';

export default Divider;
